export default __webpack_public_path__ + "static/media/afro_ciencia.ec130cc5.jpg";